import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap';

const EditarAsignacionModal = ({
    show,
    onHide,
    asignacion,
    onSave,
    loading,
    error
}) => {
    const [formData, setFormData] = useState({
        fecha_asignacion: '',
        cantidad: '',
        monto: ''
    });

    useEffect(() => {
        if (show && asignacion) {
            // Convertir fecha existente o usar fecha actual
            const fechaAsignacion = asignacion.fecha_asignacion 
                ? asignacion.fecha_asignacion.split('T')[0] // Si viene con tiempo, tomar solo la fecha
                : new Date().toISOString().split('T')[0]; // Fecha actual como fallback
                
            setFormData({
                fecha_asignacion: fechaAsignacion,
                cantidad: asignacion.cantidad || 1,
                monto: asignacion.monto || ''
            });
        }
    }, [show, asignacion]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = () => {
        if (onSave) {
            onSave(formData);
        }
    };

    const handleClose = () => {
        setFormData({
            fecha_asignacion: '',
            cantidad: '',
            monto: ''
        });
        onHide();
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Editar asignación</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Fecha de asignación</Form.Label>
                        <Form.Control
                            type="date"
                            name="fecha_asignacion"
                            value={formData.fecha_asignacion}
                            onChange={handleChange}
                        />
                        <Form.Text className="text-muted">
                            Fecha en la que se aplicará este extra al conductor
                        </Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Cantidad</Form.Label>
                        <Form.Control
                            type="number"
                            name="cantidad"
                            value={formData.cantidad}
                            min={1}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Monto</Form.Label>
                        <Form.Control
                            type="number"
                            name="monto"
                            value={formData.monto}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    {error && <Alert variant="danger">{error}</Alert>}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose} disabled={loading}>
                    Cancelar
                </Button>
                <Button variant="primary" onClick={handleSubmit} disabled={loading}>
                    {loading ? <Spinner size="sm" animation="border" /> : 'Guardar'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

EditarAsignacionModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    asignacion: PropTypes.object,
    onSave: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string
};

export default EditarAsignacionModal;
